import { Inject, Injectable, InjectionToken } from '@angular/core';
import { Logger, LoggerOptions } from './logger';

export const LOGGING_ADAPTERS = new InjectionToken<Logger>('Logger');
@Injectable()
export class MultiLogger implements Logger {
  constructor(@Inject(LOGGING_ADAPTERS) private _loggers: Logger[]) {}

  public error(
    error: Error | string,
    properties?: { [name: string]: string },
    options?: LoggerOptions,
  ) {
    this._loggers.forEach((l) => {
      l.error(error, properties, options);
    });
  }

  public warning(
    message: string,
    properties?: { [name: string]: string },
    options?: LoggerOptions,
  ) {
    this._loggers.forEach((l) => {
      l.warning(message, properties, options);
    });
  }

  public info(message: string, properties?: { [name: string]: string }, options?: LoggerOptions) {
    this._loggers.forEach((l) => {
      l.info(message, properties, options);
    });
  }
}
